import React from 'react'
import { Modal } from 'antd'
import SatisfaccionResults from './keta/satisfaccion-results'
import Gad7Calc from './keta/gad-7-calc'

import EfectosEMTResults from './emt/emt-results'

// USED AT THE TOP LEVEL EMT TABLE
// Contains the top level emt table, which has the satisfaction results, gad7 and efectos emt results. It is used in the EMT details modal, which is opened when clicking on the EMT results button in the visit details page.

export default function EfectosSatisfactionModal({ encuestaDetails, isModalOpen, setIsModalOpen }) {
    const tipo = encuestaDetails[0]?.tipo

    const calculateResults = () => {
        switch (tipo) {
            case 'satisfaccion_2':
                return <SatisfaccionResults satisfaccion={encuestaDetails[0].satisfaccion_2} />
            case 'gad_7':
                return <Gad7Calc gad7={encuestaDetails[0].gad_7} />
            case 'efectos_emt':
                return <EfectosEMTResults efectos={encuestaDetails[0].efectos_emt} />
            default:
                return (
                    <div></div>
                )
        }
    }

    return (
        <Modal title="Detalles de la encuesta" open={isModalOpen} onCancel={() => { setIsModalOpen(false) }} width={900}>
            {/* <p>{JSON.stringify(encuestaDetails)}</p> */}
            <p>Escala {tipo}</p>
            {calculateResults()}
        </Modal>
    )
}
